/* ═══════════════════════════════════════════════════════
   LUMIXULTRA — movimento e interazione
   Tutto guidato da misure reali (getBoundingClientRect):
   su questa pagina gli IntersectionObserver non scattavano.
   ═══════════════════════════════════════════════════════ */

(() => {
  'use strict';

  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const QS = new URLSearchParams(location.search);
  const PIN = QS.get('pin');
  if (PIN || QS.has('instant')) document.documentElement.style.scrollBehavior = 'auto';

  /* ───────── testo che sale, parola per parola ───────── */
  document.querySelectorAll('.split').forEach((el) => {
    const html = el.innerHTML.split(/(<br\s*\/?>)/i).map((chunk) => {
      if (/^<br/i.test(chunk)) return chunk;
      return chunk.split(/(\s+)/).map((w) => {
        if (!w.trim()) return w;
        return `<span class="w"><i>${w}</i></span>`;
      }).join('');
    }).join('');
    el.innerHTML = html;
    [...el.querySelectorAll('.w > i')].forEach((i, k) => {
      i.style.transitionDelay = `${Math.min(k * 38, 380)}ms`;
    });
  });

  /* ───────── sequenza d'ingresso ───────── */
  const start = () => document.documentElement.classList.add('ready');
  if (document.readyState === 'complete') requestAnimationFrame(start);
  else addEventListener('load', () => requestAnimationFrame(start));
  setTimeout(start, 1200);                      // rete di sicurezza

  /* ───────── elementi ───────── */
  const bar = document.getElementById('nav');
  const prog = document.getElementById('barProg');
  const railDot = document.getElementById('railDot');
  const hero = document.querySelector('.hero');
  const heroVideo = document.getElementById('stageVideo');
  const outro = document.getElementById('outro');
  const foot = document.querySelector('.foot');
  const prodotto = document.getElementById('prodotto');
  const band = document.getElementById('accensione');
  const bandLit = document.querySelector('.band-claim-lit');
  const bandStage = document.querySelector('.band-stage');
  const bandGlow = document.querySelector('.band-glow');
  const pigro = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const idxLinks = [...document.querySelectorAll('#featIdx a')];
  const frows = [...document.querySelectorAll('.frow')];

  const revealSel = '.split, .rule, .frow, .vcard, .faq, .outro .btn, .outro-note, .chi-foto li';
  const reveals = [...document.querySelectorAll(revealSel)]
    .filter((el) => !hero.contains(el));         // l'hero ha la sua sequenza

  const counters = [...document.querySelectorAll('.count')];
  const fmt = new Intl.NumberFormat('it-IT');

  function animateCount(el) {
    const target = parseFloat(el.dataset.count);
    const dec = el.dataset.format === 'dec';
    const plain = el.dataset.format === 'plain';   // 2500, non 2.500
    const set = (v) => {
      el.textContent = dec ? v.toFixed(1)
        : plain ? String(Math.round(v)) : fmt.format(Math.round(v));
    };
    if (REDUCED || PIN) { set(target); return; }
    const t0 = performance.now(), dur = 1500;
    (function step(t) {
      const p = Math.max(0, Math.min((t - t0) / dur, 1));
      set(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    })(performance.now());
  }

  function seen(el, frac) {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return r.top < innerHeight * frac && r.bottom > 0;
  }

  let lastY = scrollY;

  function scan() {
    const y = scrollY;
    const vh = innerHeight;

    for (let i = reveals.length - 1; i >= 0; i--) {
      if (seen(reveals[i], 0.9)) { reveals[i].classList.add('in'); reveals.splice(i, 1); }
    }
    for (let i = counters.length - 1; i >= 0; i--) {
      if (seen(counters[i], 0.88)) { animateCount(counters[i]); counters.splice(i, 1); }
    }
    if (band) band.classList.add('in');
    if (bandLit && !pigro) fascio(y, vh);

    // barra: sempre a schermo, e si vela appena parte lo scroll.
    // La sfumatura la fa la transizione CSS, non la soglia.
    const velo = y > 2 ? 1 : 0;
    bar.style.setProperty('--velo', velo);
    bar.classList.toggle('stuck', velo === 1);
    const max = document.documentElement.scrollHeight - vh;
    const p = max > 0 ? y / max : 0;
    if (prog) prog.style.width = (p * 100).toFixed(2) + '%';
    if (railDot) railDot.style.top = (p * 100).toFixed(2) + '%';
    lastY = y;

    // barra d'acquisto: solo dove non c'è già un bottone grande

    // indice delle caratteristiche: segna la riga che stai leggendo
    if (idxLinks.length && frows.length) {
      let active = -1;
      frows.forEach((row, k) => {
        const r = row.getBoundingClientRect();
        if (r.top < vh * 0.55) active = k;
      });
      idxLinks.forEach((a, k) => a.classList.toggle('on', k === active));
    }

    // il prodotto scorre appena più lento della pagina
    if (heroVideo && !REDUCED && y < vh * 1.2) {
      heroVideo.style.setProperty('--par', `${(y * 0.12).toFixed(1)}px`);
      heroVideo.style.marginTop = `${(y * 0.12).toFixed(1)}px`;
    }
  }

  addEventListener('scroll', scan, { passive: true });
  addEventListener('resize', scan);
  addEventListener('load', scan);
  [0, 200, 500, 900, 1500].forEach((t) => setTimeout(scan, t));

  /* ───────── video dell'hero: l'autoplay può essere rifiutato ───────── */
  if (heroVideo) {
    // un giro solo: se è già finito non lo faccio ripartire
    const play = () => {
      if (heroVideo.ended) return;
      const r = heroVideo.play();
      if (r && r.catch) r.catch(() => {});
    };
    play();
    heroVideo.addEventListener('canplay', play, { once: true });
    ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach((e) =>
      addEventListener(e, play, { once: true, passive: true }));

    // lo zoom parte poco prima della fine, così si accavalla al giro e non stacca
    const zoom = () => heroVideo.classList.add('zoom');
    heroVideo.addEventListener('timeupdate', () => {
      const d = heroVideo.duration;
      if (d && heroVideo.currentTime >= d - 1.1) zoom();
    });
    heroVideo.addEventListener('ended', zoom);
  }

  /* ═══════════════════════════════════════════════════════════
     CARRELLO SHOPIFY
     Passiamo dal carrello vero: così Shopify registra l'evento e lo
     ritrovi nelle statistiche e nei carrelli abbandonati.
     ═══════════════════════════════════════════════════════════ */
  function variantiScelte() {
    const attiva = document.querySelector('.lens-chip.active');
    const pezzi = [];
    if (attiva && attiva.dataset.vid) pezzi.push({ id: attiva.dataset.vid, quantity: 1 });
    if (terza) {
      // la terza è sempre quella che NON hai preso in regalo; i codici
      // delle due varianti stanno sul contenitore della domanda sì/no
      const altra = seconda === '2.5' ? '3.5' : '2.5';
      const picker = document.getElementById('thirdPicker');
      const id = picker && picker.dataset[altra === '2.5' ? 'vid25' : 'vid35'];
      if (id) pezzi.push({ id: id, quantity: 1 });
    }
    return pezzi;
  }

  function vaiAllaCassa(bottone) {
    const pezzi = variantiScelte();
    if (!pezzi.length) return;
    const testo = bottone.innerHTML;
    bottone.disabled = true;
    bottone.innerHTML = 'Un attimo…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: pezzi })
    })
      .then((r) => r.ok ? r.json() : Promise.reject(r.status))
      .then(() => { location.href = '/checkout'; })
      .catch(() => {
        bottone.disabled = false;
        bottone.innerHTML = testo;
        location.href = '/cart/' + pezzi.map((x) => x.id + ':' + x.quantity).join(',');
      });
  }

  /* ───────── configuratore ───────── */
  const _sez = document.getElementById('prodotto');
  const BASE = _sez ? +_sez.dataset.base || 590 : 590;
  const TERZA = _sez ? +_sez.dataset.terza || 159 : 159;
  let seconda = '2.5', terza = false;
  const totalNum = document.getElementById('totalNum');
  const buyAmount = document.getElementById('buyAmount');
  const includes = document.getElementById('includesLine');
  const lensChips = [...document.querySelectorAll('.lens-chip')];
  const thirdChips = [...document.querySelectorAll('.third-chip')];
  // il prezzo pieno mostrato barrato: lo porta la pagina (dal catalogo,
  // nel tema) e in mancanza vale 850
  const PRIMA = (_sez && +_sez.dataset.prima) || 850;
  const primaNum = document.getElementById('primaNum');
  let shown = BASE;

  function write(v) {
    if (totalNum) totalNum.textContent = v;
    if (buyAmount) buyAmount.innerHTML = V.prezzo(v);
  }

  function tween(to) {
    if (REDUCED || PIN) { shown = to; write(to); return; }
    const from = shown, t0 = performance.now(), dur = 480;
    (function step(t) {
      const p = Math.max(0, Math.min((t - t0) / dur, 1));
      shown = Math.round(from + (to - from) * (1 - Math.pow(1 - p, 3)));
      write(shown);
      if (p < 1) requestAnimationFrame(step);
    })(performance.now());
    setTimeout(() => { shown = to; write(to); }, dur + 120);
  }

  // Le etichette del configuratore le scrive il codice, quindi non le
  // traduce il tema: le scelgo qui dalla lingua della pagina, che è
  // l'attributo lang di <html> ("en" sotto /en/, "it" altrove).
  const EN = document.documentElement.lang === 'en';
  const V = EN ? {
    piuTerza: (p) => '+&euro;' + p,
    zero: '&euro;0',
    tutte: 'Includes every lens: 1.5x + 2.5x + 3.5x',
    due: (s) => `Includes lenses 1.5x + ${s}x`,
    ordineTutte: (t) => `I'd like to order the Lumix Headlight with all three lenses (1.5x + 2.5x + 3.5x). Total €${t}.`,
    ordineDue: (s, t) => `I'd like to order the Lumix Headlight with the included second lens ${s}x. Total €${t}.`,
    prezzo: (v) => '€' + v,
  } : {
    piuTerza: (p) => '+' + p + '&nbsp;€',
    zero: '0&nbsp;€',
    tutte: 'Include tutte le lenti: 1.5x + 2.5x + 3.5x',
    due: (s) => `Include lenti 1.5x + ${s}x`,
    ordineTutte: (t) => `Vorrei ordinare il Caschetto Lumix con tutte e tre le lenti (1.5x + 2.5x + 3.5x). Totale ${t} €.`,
    ordineDue: (s, t) => `Vorrei ordinare il Caschetto Lumix con la seconda lente ${s}x inclusa. Totale ${t} €.`,
    prezzo: (v) => v + '&nbsp;€',
  };

  function syncConfig() {
    // Due pulsanti, sì e no: quale delle due lenti si aggiunge lo
    // decide il codice, è sempre quella che non hai preso in regalo.
    thirdChips.forEach((chip) => {
      const scelto = (chip.dataset.scelta === 'si') === terza;
      chip.classList.toggle('active', scelto);
      chip.setAttribute('aria-checked', String(scelto));
      const p = chip.querySelector('.tc-p');
      if (p) p.innerHTML = chip.dataset.scelta === 'si' ? V.piuTerza(TERZA) : V.zero;
    });
    // il prezzo pieno segue la configurazione: lo sconto resta lo stesso
    if (primaNum) primaNum.textContent = PRIMA + (terza ? TERZA : 0);
    const tot = BASE + (terza ? TERZA : 0);
    const scala = document.getElementById('priceScale');
    if (scala) scala.style.setProperty('--fill', ((tot - BASE) / TERZA).toFixed(3));
    tween(tot);
    if (includes) {
      includes.textContent = terza ? V.tutte : V.due(seconda);
    }
    // finché non c'è il pagamento online, il bottone porta l'ordine al modulo
    // di contatto già compilato con la configurazione scelta.
    ordine = terza ? V.ordineTutte(tot) : V.ordineDue(seconda, tot);

  }

  let ordine = '';
  const buyBtn = document.getElementById('buyBtn');
  if (buyBtn) buyBtn.addEventListener('click', () => vaiAllaCassa(buyBtn));

  lensChips.forEach((chip) => chip.addEventListener('click', () => {
    seconda = chip.dataset.lens;
    lensChips.forEach((c) => {
      const on = c === chip;
      c.classList.toggle('active', on);
      c.setAttribute('aria-checked', String(on));
    });
    syncConfig();
  }));

  thirdChips.forEach((chip) => chip.addEventListener('click', () => {
    terza = chip.dataset.scelta === 'si';
    syncConfig();
  }));

  syncConfig();

  /* ───────── galleria prodotto ───────── */
  const pgMain = document.getElementById('pgMain');
  const thumbs = [...document.querySelectorAll('#pgThumbs button')];
  thumbs.forEach((btn) => btn.addEventListener('click', () => {
    pgMain.src = btn.dataset.src;
    pgMain.alt = 'LumixUltra — ' + (btn.getAttribute('aria-label') || 'vista prodotto');
    thumbs.forEach((b) => b.classList.toggle('active', b === btn));
  }));

  /* ───────── video: parte al clic ───────── */
  document.querySelectorAll('.video-frame').forEach((frame) => {
    const v = frame.querySelector('video');
    const b = frame.querySelector('.video-play');
    b.addEventListener('click', () => {
      frame.classList.add('playing');
      b.classList.add('off');
      v.controls = true;
      v.play();
    });
  });

  /* ───────── il fascio del caschetto sulla frase ─────────
     Il cono di luce attraversa il testo mentre scorri: dove è passato
     resta illuminato, e più scorri veloce più il cono si allarga. ── */
  let ultimaY = scrollY, raggio = 0;

  function fascio(y, vh) {
    const r = band.getBoundingClientRect();
    const corsa = r.height + vh;
    const grezzo = (vh - r.top) / corsa;
    // la spazzata utile: parte quando la frase è entrata, finisce al centro schermo
    let t = (grezzo - 0.24) / 0.40;
    t = t < 0 ? 0 : t > 1 ? 1 : t;

    // velocità di scroll → larghezza del cono, smorzata così non sfarfalla
    const v = Math.min(Math.abs(y - ultimaY), 90) / 90;
    ultimaY = y;
    const largo = bandStage.offsetWidth || 600;
    const obiettivo = largo * (0.32 + v * 0.30);
    raggio += (obiettivo - raggio) * 0.16;

    const bx = -18 + t * 136;          // da fuori a sinistra a fuori a destra
    const by = 30 + t * 40;            // scende in diagonale, come la testa che gira
    const scia = bx - 9;               // dove il fascio è passato resta acceso

    bandLit.style.setProperty('--bx', bx.toFixed(2) + '%');
    bandLit.style.setProperty('--by', by.toFixed(2) + '%');
    bandLit.style.setProperty('--br', raggio.toFixed(1) + 'px');
    bandLit.style.setProperty('--scia', scia.toFixed(2) + '%');

    if (bandGlow) {
      const s = bandStage.getBoundingClientRect();
      bandGlow.style.setProperty('--gx', (s.left - r.left + s.width * bx / 100).toFixed(1) + 'px');
      bandGlow.style.setProperty('--gy', (s.top - r.top + s.height * by / 100).toFixed(1) + 'px');
      bandGlow.style.opacity = t > 0.02 && t < 0.99 ? 1 : 0;
    }
  }

  /* ───────── modalità prova: ?pin=<id> per gli screenshot ───────── */
  if (PIN) {
    addEventListener('load', () => setTimeout(() => {
      const el = document.getElementById(PIN);
      if (!el) return;
      document.body.style.transform = `translateY(${-(el.getBoundingClientRect().top + scrollY)}px)`;
      document.querySelectorAll(revealSel + ', .band-claim').forEach((r) => r.classList.add('in'));
      if (band) band.classList.add('in');
      if (bandLit) { bandLit.style.setProperty('--scia', '130%'); bandLit.style.setProperty('--br', '0px'); }
      counters.splice(0).forEach(animateCount);
      document.documentElement.classList.add('ready');
    }, 400));
  }

  /* ───────── scheda tecnica: su telefono parte tutta chiusa ─────────
     Su schermo largo lasciare il primo gruppo aperto fa capire cosa c'è
     dentro; su telefono ruberebbe mezza schermata. ── */
  const stretto = matchMedia('(max-width: 760px)');
  let giaChiuso = false;
  function chiudiScheda() {
    if (giaChiuso || !stretto.matches) return;
    const primo = document.querySelector('.spec details[open]');
    if (primo) { primo.open = false; giaChiuso = true; }
  }
  chiudiScheda();
  addEventListener('load', chiudiScheda);
  stretto.addEventListener('change', chiudiScheda);



  /* ── salto all'ancora arrivando da un'altra pagina ──
     Con "scroll-behavior: smooth" sul documento il browser a volte non
     completa il salto: ci prova mentre la pagina sta ancora crescendo
     (video e immagini che riservano spazio) e resta in cima. Lo
     rifacciamo a caricamento finito, ma solo se nessuno si è mosso:
     se l'utente ha già iniziato a scorrere non lo strattoniamo. */
  (function ancora() {
    if (!location.hash || location.hash.length < 2) return;
    let fatto = false;
    const vai = () => {
      if (fatto || scrollY > 4) return;
      let el = null;
      try { el = document.querySelector(location.hash); } catch (e) { return; }
      if (!el) return;
      const prima = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      el.scrollIntoView();
      document.documentElement.style.scrollBehavior = prima;
      fatto = true;
    };
    addEventListener('load', () => requestAnimationFrame(vai));
    setTimeout(vai, 400);
    setTimeout(vai, 1000);
  })();

  /* ── visore: clic su una foto per ingrandirla, frecce per scorrere ── */
  (function visore() {
    const foto = [...document.querySelectorAll('.chi-foto img, .sc-galleria img')];
    if (!foto.length) return;
    const EN = document.documentElement.lang === 'en';

    const scatola = document.createElement('div');
    scatola.className = 'lbox';
    scatola.setAttribute('role', 'dialog');
    scatola.setAttribute('aria-modal', 'true');
    scatola.innerHTML =
      '<img alt="">' +
      '<button type="button" class="lbox-chiudi" aria-label="' + (EN ? 'Close' : 'Chiudi') + '">×</button>' +
      '<button type="button" class="lbox-prima" aria-label="' + (EN ? 'Previous photo' : 'Foto precedente') + '">‹</button>' +
      '<button type="button" class="lbox-dopo" aria-label="' + (EN ? 'Next photo' : 'Foto successiva') + '">›</button>' +
      '<p class="lbox-conta" aria-hidden="true"></p>';
    document.body.appendChild(scatola);

    const grande = scatola.querySelector('img');
    const conta = scatola.querySelector('.lbox-conta');
    let indice = 0, daRidare = null;

    function mostra(i) {
      indice = (i + foto.length) % foto.length;
      grande.src = foto[indice].currentSrc || foto[indice].src;
      grande.alt = foto[indice].alt || '';
      conta.textContent = (indice + 1) + ' / ' + foto.length;
    }
    function apri(i) {
      daRidare = document.activeElement;
      mostra(i);
      scatola.classList.add('aperto');
      document.documentElement.style.overflow = 'hidden';
      scatola.querySelector('.lbox-chiudi').focus();
    }
    function chiudi() {
      scatola.classList.remove('aperto');
      document.documentElement.style.overflow = '';
      if (daRidare && daRidare.focus) daRidare.focus();
    }

    foto.forEach((img, i) => img.addEventListener('click', () => apri(i)));
    scatola.querySelector('.lbox-chiudi').addEventListener('click', chiudi);
    scatola.querySelector('.lbox-prima').addEventListener('click', () => mostra(indice - 1));
    scatola.querySelector('.lbox-dopo').addEventListener('click', () => mostra(indice + 1));
    scatola.addEventListener('click', (e) => { if (e.target === scatola) chiudi(); });
    addEventListener('keydown', (e) => {
      if (!scatola.classList.contains('aperto')) return;
      if (e.key === 'Escape') chiudi();
      if (e.key === 'ArrowLeft') mostra(indice - 1);
      if (e.key === 'ArrowRight') mostra(indice + 1);
    });
  })();

})();
